import { DashboardConstants } from '../../actions/constant';

const {
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_REQUEST,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER,
  GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET,
} = DashboardConstants;

const intitialstate: any = {
  response: null,
  isGetDocuments: false,
  loading: false,
  pageNumber: 0,
};

export const dashboardDocumentListCsv = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_SUCCESS:
      return {
        ...state,
        isGetDocuments: true,
        response: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_FAILURE:
      return {
        ...state,
        isGetDocuments: false,
        response: action.payload,
        loading: false,
      };

    case GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_LOADER:
      return {
        ...state,
        loading: true,
      };
    case GET_DASHBOARD_ALL_SUBMITTED_CSV_DOCUMENT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
